<template>
  <v-container
    id="glUtilInterestApportionmentBase"
    class="gl-util-interest-apportionment-base"
  >
    <MiscTransactionBase
      id="glUtilInterestApportionmentMiscTransactionBase"
      class="gl-util-interest-apportionment-misc-transaction-base"
      :openMiscEditedItemFlag="openMiscEditedItemFlag"
      :baseCrudKey="baseCrudKey"
      :interestReceived="interestReceived"
    />
    <InterestApportionmentCriteria
      v-if="!isPrintScreen"
      id="glUtilInterestApportionmentCriteria"
      class="gl-util-interest-apportionment-criteria"
      :baseCrudKey="baseCrudKey"
      @viewInterestApportionmentReport="loadInterestApportionmentAndViewReport"
    />
    <InterestApportionmentReport
      :baseCrudKey="baseCrudKey"
      id="glUtilInterestApportionmentReport"
      class="gl-util-interest-apportionment-report"
      @proceedToCreateMisc="proceedToCreateMisc"
    />
  </v-container>
</template>

<script>
import {
  mapState,
  mapGetters,
  mapMutations,
  mapActions,
} from 'vuex';
import { mdiNote } from '@mdi/js';
import InterestApportionmentCriteria from './InterestApportionmentCriteria.vue';
import InterestApportionmentReport from './InterestApportionmentReport.vue';
import MiscTransactionBase from './MiscTransactionBase.vue';
import { toIsoDate } from '../../../util/shared/tmc-global';

export default {
  components: {
    MiscTransactionBase,
    InterestApportionmentCriteria,
    InterestApportionmentReport,
  },
  created() {
  },
  data: () => ({
    baseCrudKey: 'glInterestApportionment',
    icons: {
      mdiNote,
    },
    interestReceived: 0,
    openMiscEditedItemFlag: 0,
  }),
  computed: {
    ...mapState({
      isPrintScreen: (state) => state.isPrintScreen,
    }),
    ...mapGetters('base/crud', [
      'criteria',
    ]),
    criteriaState: {
      get() {
        return this.criteria(this.baseCrudKey);
      },
      set(value) {
        this.setCriteria([this.baseCrudKey, value]);
      },
    },
  },
  methods: {
    ...mapMutations('base/crud', [
      'setCriteria',
    ]),
    ...mapActions('glDaily/interestApportionment', [
      'loadInterestApportionment',
    ]),
    ...mapActions('glDaily/glDailyTransaction', [
      'loadFiscalRegYears',
    ]),
    proceedToCreateMisc() {
      this.openMiscEditedItemFlag += 1;
    },
    loadInterestApportionmentAndViewReport() {
      const criteria = { ...this.criteriaState };
      this.loadInterestApportionmentData(criteria);
    },
    loadInterestApportionmentData(criteria) {
      // console.info('--criteria---', criteria);
      const requestCriteria = {
        fiscalYear: criteria.fiscalYear,
        fromBusinessDate: toIsoDate(criteria.fromDate),
        toBusinessDate: toIsoDate(criteria.toDate),
        interestReceived: criteria.interestReceived,
      };
      this.interestReceived = criteria.interestReceived;
      // console.info('--requestCriteria---', requestCriteria);
      this.loadInterestApportionment({ criteria: requestCriteria, baseCrudKey: 'glInterestApportionment' });
    },
  },
};
</script>
